// SPDX-License-Identifier: AGPL-3.0-or-later

import styles from '@app/features/table_game_leaderboard/components/LeagueBadge.module.css';
import type {TableGameLeague} from '@fluxer/constants/src/TableGameConstants';
import {CrownSimpleIcon, ShieldIcon} from '@phosphor-icons/react';
import {clsx} from 'clsx';

// A still icon in the league colour: list rows and profile badges show many of them at once.
export function LeagueBadge({league, label, className}: {league: TableGameLeague; label?: string; className?: string}) {
	const Icon = league === 'legend' ? CrownSimpleIcon : ShieldIcon;
	const icon = <Icon weight="fill" className={styles.icon} data-flx="table-game-leaderboard.league-badge.icon" />;
	return label ? (
		<span
			role="img"
			aria-label={label}
			className={clsx(styles.badge, className)}
			data-league={league}
			data-flx="table-game-leaderboard.league-badge"
		>
			{icon}
		</span>
	) : (
		<span
			aria-hidden
			className={clsx(styles.badge, className)}
			data-league={league}
			data-flx="table-game-leaderboard.league-badge"
		>
			{icon}
		</span>
	);
}
